import React__default, { useMemo, useState, useEffect } from 'react';
import { I as IntlProvider$1 } from './3rdPartyModules/react-intl/lib/src/components/provider-08b9e6c8-56c5eb49.js';

/* eslint-disable react-hooks/exhaustive-deps */
function InternalIntlProvider({
  translations,
  children
}) {
  const {
    locale
  } = translations;
  const InitalTranslationComponent = useMemo(() => translations.component, []);
  const [translationMap, setTranslationsMap] = useState(undefined);
  useEffect(() => {
    if (translations.translationImports && translations.translationImports[locale]) {
      translations.translationImports[locale]().then(res => {
        setTranslationsMap(res.default.translations);
      });
    } else if ('translations' in translations.component) {
      setTranslationsMap(translations.component.translations);
    }
  }, [locale]);
  return /*#__PURE__*/React__default.createElement(InitalTranslationComponent, null, initalTranslationsMap => /*#__PURE__*/React__default.createElement(IntlProvider$1, {
    key: locale,
    locale: locale,
    defaultLocale: "en-US",
    messages: translationMap !== null && translationMap !== void 0 ? translationMap : initalTranslationsMap
  }, children));
}

export { InternalIntlProvider as I };
//# sourceMappingURL=Provider-66d81f6b-1e975b77.js.map
